<template>
  <div class="ly-editor">
    <div class="editor">
      <div v-if="editor && isWrite" class="editor-btn">
        <div>
          <div class="ly-in-block">
            <el-button
              title="굵게"
              class="editor-icon"
              @click="editor.chain().focus().toggleBold().run()"
              :class="{ 'is-active': editor.isActive('bold') }"
              icon
            >
              <i class="icon-TextBolder" />
            </el-button>
            <el-button
              title="기울임꼴"
              class="editor-icon"
              @click="editor.chain().focus().toggleItalic().run()"
              :class="{ 'is-active': editor.isActive('italic') }"
            >
              <i class="icon-TextItalic" />
            </el-button>
            <el-button
              title="밑줄"
              class="editor-icon"
              @click="editor.chain().focus().toggleUnderline().run()"
              :class="{ 'is-active': editor.isActive('underline') }"
            >
              <i class="icon-TextUnderline" />
            </el-button>
            <div class="ly-editor-btns">
              <el-button
                title="배경색"
                class="editor-icon"
                type="highlight-color"
                @click="onHighlight"
                :class="isActiveH"
              />
              <div
                class="ly-editor-toggle"
                v-if="toggleH"
                style="width: 180px; display: block"
              >
                <el-button
                  title="검정색"
                  class="editor-icon"
                  @click="
                    editor
                      .chain()
                      .focus()
                      .toggleHighlight({ color: '#333333' })
                      .run()
                  "
                  :class="{
                    'is-active': editor.isActive('highlight', {
                      color: '#333333',
                    }),
                  }"
                >
                  <span class="color-chip" style="background: #333333"></span>
                </el-button>
                <el-button
                  title="진한회색"
                  class="editor-icon"
                  @click="
                    editor
                      .chain()
                      .focus()
                      .toggleHighlight({ color: '#5E5E5E' })
                      .run()
                  "
                  :class="{
                    'is-active': editor.isActive('highlight', {
                      color: '#5E5E5E',
                    }),
                  }"
                >
                  <span class="color-chip" style="background: #5e5e5e"></span>
                </el-button>
                <el-button
                  title="회색"
                  class="editor-icon"
                  @click="
                    editor
                      .chain()
                      .focus()
                      .toggleHighlight({ color: '#8E8E8E' })
                      .run()
                  "
                  :class="{
                    'is-active': editor.isActive('highlight', {
                      color: '#8E8E8E',
                    }),
                  }"
                >
                  <span class="color-chip" style="background: #8e8e8e"></span>
                </el-button>
                <el-button
                  title="빨간색"
                  class="editor-icon"
                  @click="
                    editor
                      .chain()
                      .focus()
                      .toggleHighlight({ color: '#ED2028' })
                      .run()
                  "
                  :class="{
                    'is-active': editor.isActive('highlight', {
                      color: '#ED2028',
                    }),
                  }"
                >
                  <span class="color-chip" style="background: #ed2028"></span>
                </el-button>
                <el-button
                  title="파란색"
                  class="editor-icon"
                  @click="
                    editor
                      .chain()
                      .focus()
                      .toggleHighlight({ color: '#34558A' })
                      .run()
                  "
                  :class="{
                    'is-active': editor.isActive('highlight', {
                      color: '#34558A',
                    }),
                  }"
                >
                  <span class="color-chip" style="background: #34558a"></span>
                </el-button>
                <el-button
                  title="하늘색"
                  class="editor-icon"
                  @click="
                    editor
                      .chain()
                      .focus()
                      .toggleHighlight({ color: '#24C4DC' })
                      .run()
                  "
                  :class="{
                    'is-active': editor.isActive('highlight', {
                      color: '#24C4DC',
                    }),
                  }"
                >
                  <span class="color-chip" style="background: #24c4dc"></span>
                </el-button>
                <el-button
                  title="주황색"
                  class="editor-icon"
                  @click="
                    editor
                      .chain()
                      .focus()
                      .toggleHighlight({ color: '#ED8220' })
                      .run()
                  "
                  :class="{
                    'is-active': editor.isActive('highlight', {
                      color: '#ED8220',
                    }),
                  }"
                >
                  <span class="color-chip" style="background: #ed8220"></span>
                </el-button>
                <el-button
                  title="보라색"
                  class="editor-icon"
                  @click="
                    editor
                      .chain()
                      .focus()
                      .toggleHighlight({ color: '#7556F0' })
                      .run()
                  "
                  :class="{
                    'is-active': editor.isActive('highlight', {
                      color: '#7556F0',
                    }),
                  }"
                >
                  <span class="color-chip" style="background: #7556f0"></span>
                </el-button>
              </div>
            </div>
            <div class="ly-editor-btns">
              <el-button
                title="글자색"
                class="editor-icon"
                type="txt-color"
                @click="onColor"
                :class="isActiveC"
              />
              <div class="ly-editor-toggle" v-if="toggleC" style="width: 200px">
                <input
                  title="사용자 지정색"
                  type="color"
                  @input="
                    editor.chain().focus().setColor($event.target.value).run()
                  "
                  :value="editor.getAttributes('textStyle').color"
                />
                <el-button
                  title="검정색"
                  class="editor-icon"
                  @click="editor.chain().focus().setColor('#333333').run()"
                  :class="{
                    'is-active': editor.isActive('textStyle', {
                      color: '#333333',
                    }),
                  }"
                >
                  <span class="color-chip" style="background: #333333"></span>
                </el-button>
                <el-button
                  title="진한회색"
                  class="editor-icon"
                  @click="editor.chain().focus().setColor('#5E5E5E').run()"
                  :class="{
                    'is-active': editor.isActive('textStyle', {
                      color: '#5E5E5E',
                    }),
                  }"
                >
                  <span class="color-chip" style="background: #5e5e5e"></span>
                </el-button>
                <el-button
                  title="회색"
                  class="editor-icon"
                  @click="editor.chain().focus().setColor('#8E8E8E').run()"
                  :class="{
                    'is-active': editor.isActive('textStyle', {
                      color: '#8E8E8E',
                    }),
                  }"
                >
                  <span class="color-chip" style="background: #8e8e8e"></span>
                </el-button>
                <el-button
                  title="빨간색"
                  class="editor-icon"
                  @click="editor.chain().focus().setColor('#ED2028').run()"
                  :class="{
                    'is-active': editor.isActive('textStyle', {
                      color: '#ED2028',
                    }),
                  }"
                >
                  <span class="color-chip" style="background: #ed2028"></span>
                </el-button>
                <el-button
                  title="파란색"
                  class="editor-icon"
                  @click="editor.chain().focus().setColor('#34558A').run()"
                  :class="{
                    'is-active': editor.isActive('textStyle', {
                      color: '#34558A',
                    }),
                  }"
                >
                  <span class="color-chip" style="background: #34558a"></span>
                </el-button>
                <el-button
                  title="하늘색"
                  class="editor-icon"
                  @click="editor.chain().focus().setColor('#24C4DC').run()"
                  :class="{
                    'is-active': editor.isActive('textStyle', {
                      color: '#24C4DC',
                    }),
                  }"
                >
                  <span class="color-chip" style="background: #24c4dc"></span>
                </el-button>
                <el-button
                  title="주황색"
                  class="editor-icon"
                  @click="editor.chain().focus().setColor('#ED8220').run()"
                  :class="{
                    'is-active': editor.isActive('textStyle', {
                      color: '#ED8220',
                    }),
                  }"
                >
                  <span class="color-chip" style="background: #ed8220"></span>
                </el-button>
                <el-button
                  title="보라색"
                  class="editor-icon"
                  @click="editor.chain().focus().setColor('#7556F0').run()"
                  :class="{
                    'is-active': editor.isActive('textStyle', {
                      color: '#7556F0',
                    }),
                  }"
                >
                  <span class="color-chip" style="background: #7556f0"></span>
                </el-button>
              </div>
            </div>
          </div>
          <div class="ly-in-block">
            <div class="ly-editor-btns">
              <el-button
                title="정렬"
                class="editor-icon"
                @click="onTextAlign"
                :class="isActiveA"
              >
                <i class="icon-TextAlignLeft" />
              </el-button>
              <div class="ly-editor-toggle" v-if="toggleA" style="width: 70px">
                <el-button
                  title="좌측 정렬"
                  class="editor-icon"
                  @click="editor.chain().focus().setTextAlign('left').run()"
                  :class="{
                    'is-active': editor.isActive({ textAlign: 'left' }),
                  }"
                >
                  <i class="icon-TextAlignLeft" />
                </el-button>
                <el-button
                  title="가운데 정렬"
                  class="editor-icon"
                  @click="editor.chain().focus().setTextAlign('center').run()"
                  :class="{
                    'is-active': editor.isActive({ textAlign: 'center' }),
                  }"
                >
                  <i class="icon-TextAlignCenter" />
                </el-button>
                <el-button
                  title="우측 정렬"
                  class="editor-icon"
                  @click="editor.chain().focus().setTextAlign('right').run()"
                  :class="{
                    'is-active': editor.isActive({ textAlign: 'right' }),
                  }"
                >
                  <i class="icon-TextAlignRight" />
                </el-button>
              </div>
            </div>

            <el-button
              title="헤더 타이틀(대)"
              class="editor-icon"
              @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
              :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }"
            >
              <i class="icon-TextHOne" />
            </el-button>
            <el-button
              title="헤더 타이틀(중)"
              class="editor-icon"
              @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
              :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }"
            >
              <i class="icon-TextHTwo" />
            </el-button>
            <el-button
              title="헤더 타이틀(소)"
              class="editor-icon"
              @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
              :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }"
            >
              <i class="icon-TextHThree" />
            </el-button>
          </div>
          <div class="ly-in-block">
            <el-button
              title="점 리스트"
              class="editor-icon"
              @click="editor.chain().focus().toggleBulletList().run()"
              :class="{ 'is-active': editor.isActive('bulletList') }"
            >
              <i class="icon-ListBullets" />
            </el-button>
            <el-button
              title="순번 리스트"
              class="editor-icon"
              @click="editor.chain().focus().toggleOrderedList().run()"
              :class="{ 'is-active': editor.isActive('orderedList') }"
            >
              <i class="icon-ListNumbers" />
            </el-button>
          </div>
          <div class="ly-in-block">
            <div class="ly-editor-btns">
              <el-button
                title="사진 첨부"
                class="editor-icon"
                :class="isActiveI"
                @click="onAddImage"
                ><i class="icon-Image"
              /></el-button>
              <div class="ly-img-toggle" v-if="toggleI">
                <idc-file-upload-cmnty
                  :fileList="fileList"
                  @handleChange="handleChange"
                />
                <p class="ly-img-txt">
                  첨부 가능 파일 확장자 : jpg, jpeg, png, gif<br />
                  여러개 이미지 등록 또한 가능합니다.
                </p>
                <div class="ly-img-btn">
                  <el-button
                    size="small"
                    type="info"
                    @click="toggleI = false"
                    >{{ $t("messages.btnCancel") }}</el-button
                  >
                  <el-button size="small" type="save" @click="addImage"
                    >추가</el-button
                  >
                </div>
              </div>
            </div>
            <el-button
              title="표 첨부"
              class="editor-icon"
              @click="
                editor
                  .chain()
                  .focus()
                  .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
                  .createParagraphNear()
                  .run()
              "
            >
              <i class="icon-Table" />
            </el-button>
          </div>
          <div class="ly-in-block">
            <el-button
              title="링크 첨부"
              class="editor-icon"
              @click="setLink"
              :class="{ 'is-active': editor.isActive('link') }"
            >
              <i class="icon-Link" />
            </el-button>
          </div>
          <div class="ly-in-block">
            <div style="display: inline; float: left; position: relative; margin-top: 7px; margin-right: 5px;">표 제어</div>
            <el-button
              title="열 추가"
              type="addColumnAfter"
              class="editor-icon"
              @click="editor.chain().focus().addColumnAfter().run()"
            />
            <el-button
              title="행 추가"
              type="addRowAfter"
              class="editor-icon"
              @click="editor.chain().focus().addRowAfter().run()"
            />
            <el-button
              title="열 제거"
              type="deleteColumn"
              class="editor-icon"
              @click="editor.chain().focus().deleteColumn().run()"
            />
            <el-button
              title="행 제거"
              type="deleteRow"
              class="editor-icon"
              @click="editor.chain().focus().deleteRow().run()"
            />
            <el-button
              title="셀 병합"
              class="editor-icon"
              @click="editor.chain().focus().mergeCells().run()"
            >
              <i class="icon-ArrowsInLineHorizontal" />
            </el-button>
            <el-button
              title="셀 나누기"
              class="editor-icon"
              @click="editor.chain().focus().splitCell().run()"
            >
              <i class="icon-ArrowsOutLineHorizontal" />
            </el-button>
            <el-button
              title="행 배경색"
              type="toggleHeaderColumn"
              class="editor-icon"
              @click="editor.chain().focus().toggleHeaderRow().run()"
            />
            <el-button
              title="열 배경색"
              type="toggleHeaderRow"
              class="editor-icon"
              @click="editor.chain().focus().toggleHeaderColumn().run()"
            />
            <el-button
              title="표 제거"
              class="editor-icon"
              @click="editor.chain().focus().deleteTable().run()"
            >
              <i class="icon-Trash" />
            </el-button>
          </div>
        </div>
        <div class="btn-do">
          <el-button
            title="실행취소"
            class="editor-icon"
            @click="editor.chain().focus().undo().run()"
          >
            <i class="icon-ArrowArcLeft" />
          </el-button>

          <el-button
            title="다시실행"
            class="editor-icon"
            @click="editor.chain().focus().redo().run()"
          >
            <i class="icon-ArrowArcRight" />
          </el-button>
        </div>
      </div>
      <!-- <bubble-menu
        class="table-editor"
        :editor="editor"
        v-if="editor && isWrite"
        :shouldShow="shouldShow"
      >
        <div class="ly-in-block">
          <el-button
            type="addColumnAfter"
            class="editor-icon"
            @click="editor.chain().focus().addColumnAfter().run()"
          />
          <el-button
            type="addRowAfter"
            class="editor-icon"
            @click="editor.chain().focus().addRowAfter().run()"
          />
          <el-button
            type="deleteColumn"
            class="editor-icon"
            @click="editor.chain().focus().deleteColumn().run()"
          />

          <el-button
            type="deleteRow"
            class="editor-icon"
            @click="editor.chain().focus().deleteRow().run()"
          />
        </div>
        <div class="ly-in-block">
          <el-button
            class="editor-icon"
            @click="editor.chain().focus().mergeCells().run()"
          >
            <i class="icon-ArrowsInLineHorizontal" />
          </el-button>

          <el-button
            class="editor-icon"
            @click="editor.chain().focus().splitCell().run()"
          >
            <i class="icon-ArrowsOutLineHorizontal" />
          </el-button>
        </div>
        <div class="ly-in-block">
          <el-button
            type="toggleHeaderColumn"
            class="editor-icon"
            @click="editor.chain().focus().toggleHeaderColumn().run()"
          />
          <el-button
            type="toggleHeaderRow"
            class="editor-icon"
            @click="editor.chain().focus().toggleHeaderRow().run()"
          />

          <el-button
            class="editor-icon"
            @click="editor.chain().focus().deleteTable().run()"
          >
            <i class="icon-Trash" />
          </el-button>
        </div>
      </bubble-menu> -->
      <editor-content :editor="editor" :class="type == 'wrk'?'con-editor wrk-editor':'con-editor'" />
    </div>
  </div>
</template>

<script>
// FloatingMenu
import { Editor, EditorContent, BubbleMenu } from "@tiptap/vue-2";
import StarterKit from "@tiptap/starter-kit";
import Document from "@tiptap/extension-document";
import Paragraph from "@tiptap/extension-paragraph";
import Text from "@tiptap/extension-text";
import Table from "@tiptap/extension-table";
import TableRow from "@tiptap/extension-table-row";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import Gapcursor from "@tiptap/extension-gapcursor";
import TextAlign from "@tiptap/extension-text-align";
import Heading from "@tiptap/extension-heading";
import Highlight from "@tiptap/extension-highlight";
import TextStyle from "@tiptap/extension-text-style";
import { Color } from "@tiptap/extension-color";
import Link from "@tiptap/extension-link";
import Image from "@tiptap/extension-image";
import Underline from "@tiptap/extension-underline";
//import IdcFileUpload from "./IdcFileUpload";
import IdcFileUploadCmnty from "@/components/common/IdcFileUploadCmnty";
// import { FloatingMenu } from "@tiptap/extension-floating-menu";
export default {
  components: {
    EditorContent,
    BubbleMenu,
    //IdcFileUpload,
    IdcFileUploadCmnty,
  },
  props: {
    editorHtmlContent: {
      value: String,
      default: "",
    },
    isWrite: {
      value: Boolean,
      default: true,
    },
    type:{
      value: String,
      default: "",
    }
  },
  data() {
    return {
      editor: null,
      toggleH: false,
      toggleC: false,
      toggleA: false,
      toggleI: false,
      isActiveH: "",
      isActiveC: "",
      isActiveA: "",
      isActiveI: "",
      fileList: [],
    };
  },
  mounted() {
    console.log('type', this.type)
    this.editor = new Editor({
      extensions: [
        StarterKit,
        Document,
        Paragraph,
        Text,
        Gapcursor,
        Table.configure({
          resizable: true,
        }),
        TableRow,
        TableHeader,
        TableCell,
        Heading,
        TextStyle,
        Color,
        TextAlign.configure({
          types: ["heading", "paragraph"],
        }),
        Highlight.configure({ multicolor: true }),
        Link.configure({
          openOnClick: false,
        }),
        // FloatingMenu.configure({
        //   shouldShow: ({ editor, view, state, oldState }) => {
        //     // show the floating within any paragraph
        //     return editor.isActive("paragraph");
        //   },
        // }),
        Image.configure({
          inline: true,
          allowBase64: true,
        }),
        Underline,
      ],

      //텍스트 변경시 체크 후 부모에게 JSON타입으로 전달
      onUpdate: ({ getJSON }) => {
        this.$emit("child", this.editor.getJSON());
        this.$emit("getEditorContent", this.editor.getHTML());
      },

      content: this.editorHtmlContent,
      editable: this.isWrite,
    });
  },

  //조회된 데이터를 에디터 입력란에 셋팅
  watch: {
    editorHtmlContent(newContent) {
      //포커싱 체크하여 스페이스바 정상 동작하도록 수정
      if(!this.editor.isFocused){
        this.editor.commands.setContent(newContent);
      }
    },
    editor() {
      if (this.editor == true) {
        this.editor = new Editor({
          extensions: [
            StarterKit,
            Document,
            Paragraph,
            Text,
            Gapcursor,
            Table.configure({
              resizable: true,
            }),
            TableRow,
            TableHeader,
            TableCell,
            Heading,
            TextStyle,
            Color,
            TextAlign.configure({
              types: ["heading", "paragraph"],
            }),
            Highlight.configure({ multicolor: true }),
            Link.configure({
              openOnClick: false,
            }),
            // FloatingMenu.configure({
            //   shouldShow: ({ editor, view, state, oldState }) => {
            //     // show the floating within any paragraph
            //     return editor.isActive("paragraph");
            //   },
            // }),
            Image.configure({
              inline: true,
              allowBase64: true,
            }),
            Underline,
          ],

          //텍스트 변경시 체크 후 부모에게 JSON타입으로 전달
          onUpdate: ({ getJSON }) => {
            this.$emit("child", this.editor.getJSON());
            this.$emit("getEditorContent", this.editor.getHTML());
          },

          content: this.editorHtmlContent,
          editable: this.isWrite,
        });
      }
    },
  },
  methods: {
    setOptions(option) {
      this.editor.setOptions(option);
    },
    shouldShow() {
      return this.editor.isActive("table");
    },
    resetEditor() {
      this.editor.commands.clearContent(true);
    },
    setLink() {
      const previousUrl = this.editor.getAttributes("link").href;
      const url = window.prompt("URL", previousUrl);

      // cancelled
      if (url === null) {
        return;
      }

      // empty
      if (url === "") {
        this.editor.chain().focus().extendMarkRange("link").unsetLink().run();

        return;
      } else {
        let urlChk = null;
        urlChk = /^http[s]?\:\/\//i;

        if (!urlChk.test(url)) {
          alert("http:// 또는 https://를 입력하세요.");
          return;
        }
      }

      // update link
      this.editor
        .chain()
        .focus()
        .extendMarkRange("link")
        .setLink({ href: url })
        .setUnderline()
        .setColor("#68cef8")
        .run();
    },

    addImage() {
      /* const url = window.prompt("URL");
      this.editor.chain().focus().setImage({ src: url }).run(); */
      let fList = null;
      fList = this.fileList;

      let rst = false;
      for (let i = 0; i < fList.length; i++) {
        let file = fList[i].raw;

        let fileNm = "";
        let lastDot = 0;
        let fileExt = "";

        fileNm = file.name;
        lastDot = fileNm.lastIndexOf(".");

        fileExt = fileNm.substring(lastDot + 1, fileNm.length).toLowerCase();

        if (
          fileExt == "jpg" ||
          fileExt == "jpeg" ||
          fileExt == "png" ||
          fileExt == "gif"
        ) {
          rst = true;
        } else {
          rst = false;
          break;
        }
      }

      if (rst) {
        let vue = this;
        function readImgFile(idx) {
          if (idx >= fList.length) {
            return;
          }

          let f = fList[idx];
          let reader = new FileReader();

          let editorChain = null;
          editorChain = vue.editor.chain().focus();
          reader.onloadend = function (e) {
            let imgs = e.target.result;
            editorChain.setImage({ src: imgs }).createParagraphNear().run();

            setTimeout(function () {
              readImgFile(idx + 1);
            }, 500);
          };

          reader.readAsDataURL(f.raw);
        }

        readImgFile(0);
      } else {
        alert("첨부 가능 파일 확장자를 확인하세요.");
      }

      this.toggleI = false;
      this.fileList = [];
    },
    onHighlight() {
      this.toggleH = !this.toggleH;
      if (this.toggleH) {
        this.isActiveH = "is-active";
        this.isActiveC = "";
        this.isActiveA = "";
        this.isActiveI = "";
      } else {
        this.isActiveH = "";
      }
      this.toggleC = false;
      this.toggleA = false;
      this.toggleI = false;
    },
    onColor() {
      this.toggleC = !this.toggleC;
      if (this.toggleC) {
        this.isActiveH = "";
        this.isActiveC = "is-active";
        this.isActiveA = "";
        this.isActiveI = "";
      } else {
        this.isActiveC = "";
      }
      this.toggleH = false;
      this.toggleA = false;
      this.toggleI = false;
    },
    onTextAlign() {
      this.toggleA = !this.toggleA;
      if (this.toggleA) {
        this.isActiveH = "";
        this.isActiveA = "is-active";
        this.isActiveC = "";
        this.isActiveI = "";
      } else {
        this.isActiveA = "";
      }
      this.toggleH = false;
      this.toggleC = false;
      this.toggleI = false;
    },
    onAddImage() {
      this.toggleI = !this.toggleI;
      if (this.toggleA) {
        this.isActiveH = "";
        this.isActiveA = "";
        this.isActiveI = "is-active";
        this.isActiveC = "";
      } else {
        this.isActiveI = "";
      }
      this.toggleA = false;
      this.toggleH = false;
      this.toggleC = false;
    },
    beforeUnmount() {
      this.editor.destroy();
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
  },
};
</script>

<style lang="scss">
/* Basic editor styles */
.ly {
  &-editor {
    .table-editor {
      background: $--color-white;
    }
    .editor-icon {
      display: inline-block;
      width: 30px;
      height: 30px;
      font-size: $--font-size-large;
      padding: 0;
      vertical-align: top;
      line-height: 32px;
      color: $--color-black;
      border: none;
      @include mobile {
        width: 18px;
        height: 18px;
        line-height: 22px;
        font-size: $--font-size-medium;
      }

      & + .editor-icon {
        margin-left: 2px;
        @include mobile {
          margin-left: 5px;
        }
      }
      &.is-active {
        background-color: $--color-black;
        color: $--color-white;
      }
    }
    .editor {
      border: 1px solid $--color-light-gray {
        radius: 5px;
      }
      &-btn {
        display: flex;
        position: relative;
        max-height: 40px;
        padding: 5px;
        justify-content: space-between;
        align-content: center;
        z-index: 1;
        white-space: pre;
        overflow: hidden;
        @include mobile {
          max-height: 50px;
          div {
            &:last-child {
              flex: 0 0 50px;
            }
          }
        }
        .btn-do{
          position: absolute;
          right: 0;
          padding: 0 5px;
          background-color: $--color-white;
          border-left: 1px solid #e5e5e5;
        }
      }
    }
    .ly-in-block {
      margin-right: 10px;
      padding-right: 10px;
      &:not(:last-child) {
        border-right: 1px solid $--color-light-gray;
      }
      @include mobile {
        margin-right: 0;
        padding-right: 5px;
        &:not(:last-child) {
          border-right: none;
        }
        &:last-child {
          border-right: 1px solid $--color-light-gray;
        }
      }
    }
  }
  &-editor-btns {
    position: relative;
    display: inline-block;
    vertical-align: top;
    height: 20px;
    margin: 0 2px;
    @include mobile {
      margin: 0 5px;
    }
  }
  &-editor-toggle {
    position: absolute;
    padding: 2px;
    top: 36px;
    left: 0;
    background: $--color-white;
    border: 1px solid $--color-light-gray {
      radius: 0px 0px 5px 5px;
    }
    .editor-icon {
      border: 0;
      width: 20px;
      height: 20px;
      line-height: 20px;
      font-size: $--font-size-extra-small;
      .color-chip {
        display: block;
        width: 10px;
        height: 10px;
        border-radius: 2px;
        margin: 0 auto;
      }
    }
    input {
      width: 20px;
      height: 20px;
      padding: 0;
      border: 0;
    }
  }
  &-img {
    &-toggle {
      position: absolute;
      padding: 2px;
      width: 300px;
      top: 25px;
      left: 0;
      padding: 10px;
      background: $--color-white;
      border: 1px solid $--color-light-gray {
        radius: 0px 0px 5px 5px;
      }
    }
    &-txt {
      padding: 10px;
      font-size: $--font-size-small;
      line-height: 20px;
      color: $--text-nodata;
    }
    &-btn {
      text-align: right;
      .el-button {
        font-size: $--font-size-small;
        padding: 5px;
        & + .el-button {
          margin-left: 5px;
        }
      }
    }
  }
}
.btn-wrap-editor {
  padding: 5px;
  > button {
    // width: 20px;
    // height: 20px;
    background: transparent;
    padding: 0;
    &:not(:last-child) {
      margin-left: 2px;
    }
  }
}
.con-editor {
  padding: 15px;
  border-top: 1px solid $--color-light-gray;
  min-height: 216px;
  overflow-y: auto;
  .ProseMirror {
    min-height: 185px;
    > * + * {
      margin-top: 0.75em;
    }

    ul,
    ol {
      padding: 0 1rem;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      line-height: 1.1;
      font-weight: 700;
    }
    p {
      font-size: 1rem;
    }
    h {
      &1 {
        font-size: 2rem;
      }
      &2 {
        font-size: 1.5rem;
      }
      &3 {
        font-size: 1.17em;
      }
    }

    ul {
      list-style-type: disc;
    }
    ol {
      list-style-type: decimal;
    }
    code {
      background-color: rgba(#616161, 0.1);
      color: #616161;
    }

    pre {
      background: #0d0d0d;
      color: #fff;
      font-family: "JetBrainsMono", monospace;
      padding: 0.75rem 1rem;
      border-radius: 0.5rem;

      code {
        color: inherit;
        padding: 0;
        background: none;
        font-size: 0.8rem;
      }
    }

    img {
      max-width: 100%;
      height: auto;
    }

    blockquote {
      padding-left: 1rem;
      border-left: 2px solid rgba(#0d0d0d, 0.1);
    }

    hr {
      border: none;
      border-top: 2px solid rgba(#0d0d0d, 0.1);
      margin: 2rem 0;
    }
    strong {
      font-weight: 700;
    }
    em {
      font-style: italic;
    }
    s {
      text-decoration: line-through;
    }
    table {
      border-collapse: collapse;
      table-layout: fixed;
      width: 100%;
      margin: 0;
      overflow: hidden;

      td,
      th {
        min-width: 1em;
        border: 2px solid #ced4da;
        padding: 3px 5px;
        vertical-align: top;
        box-sizing: border-box;
        position: relative;

        > * {
          margin-bottom: 0;
        }
      }

      th {
        font-weight: bold;
        text-align: left;
        background-color: #f1f3f5;
      }

      .selectedCell:after {
        z-index: 2;
        position: absolute;
        content: "";
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(200, 200, 255, 0.4);
        pointer-events: none;
      }

      .column-resize-handle {
        position: absolute;
        right: -2px;
        top: 0;
        bottom: -2px;
        width: 4px;
        background-color: #adf;
        pointer-events: none;
      }

      p {
        margin: 0;
      }
    }
    .mark {
      background: #f00;
    }
    a {
      color: #68cef8;
    }
    &-focused {
      outline: 0;
    }
  }

  .tableWrapper {
    overflow-x: auto;
  }

  .resize-cursor {
    cursor: ew-resize;
    cursor: col-resize;
  }
}
.wrk-editor {
  min-height: 81px;
  .ProseMirror {
    min-height: 50px;
  }
}
// 툴팁 버튼 이미지 업로드 창
.ly-img-toggle {
  .ly-upload {
    min-height: 36px;
    height: auto;
    .el-upload-dragger {
      height: 36px;
      > .el-button--mini {
        height: 26px !important;
      }
    }
    .el-upload-list {
      position: static;
      width: 180px;
      height: 100% !important;
      align-items: flex-start !important;
      flex-direction: column;
      background-color: transparent;
      display: flex;
      border: 1px solid #e5e5e5;
      border-radius: 4px;
      .el-upload-list__item {
        &:not(:first-child):not(:last-child) {
          border-bottom: 1px solid #e5e5e5;
        }
      }
    }
  }
}
</style>
